export const regexMobile = /^(\+\d{1,2})?[\d\s]{1,25}$/;

export const regexMobileNullable = /^(\+\d{1,2})?[\d\s]{1,25}$|^$/;
